export const BREAKPOINTS = {
  desktop: 1680,
  laptop: 1072,
  tablet: 711,
  mobile: 0,
}

export const TENANTS: {
  [K in Tenant]: {
    id: Tenant
    number: number
    locale: Locale
    url: string
    subdomain: string
    category: string
  }
} = {
  bernerzeitung: {
    id: 'bernerzeitung',
    number: 3,
    locale: 'de',
    url: 'bernerzeitung.ch',
    subdomain: 'interaktiv',
    category: 'Interaktiv',
  },
  berneroberlaender: {
    id: 'berneroberlaender',
    number: 8,
    locale: 'de',
    url: 'berneroberlaender.ch',
    subdomain: 'interaktiv',
    category: 'Interaktiv',
  },
  langenthalertagblatt: {
    id: 'langenthalertagblatt',
    number: 10,
    locale: 'de',
    url: 'https://www.langenthalertagblatt.ch/',
    subdomain: 'interaktiv',
    category: 'Interaktiv',
  },
  thunertagblatt: {
    id: 'thunertagblatt',
    number: 9,
    locale: 'de',
    url: 'thunertagblatt.ch',
    subdomain: 'interaktiv',
    category: 'Interaktiv',
  },
  zsz: {
    id: 'zsz',
    number: 11,
    locale: 'de',
    url: 'zsz.ch',
    subdomain: 'interactif',
    category: 'Interaktiv',
  },
  tdg: {
    id: 'tdg',
    number: 14,
    locale: 'fr',
    url: 'tdg.ch',
    subdomain: 'interaktiv',
    category: 'Interactif',
  },
  zuonline: {
    id: 'zuonline',
    number: 13,
    locale: 'de',
    url: 'zuonline.ch',
    subdomain: 'interaktiv',
    category: 'Interaktiv',
  },
  landbote: {
    id: 'landbote',
    number: 12,
    locale: 'de',
    url: 'landbote.ch',
    subdomain: 'interaktiv',
    category: 'Interaktiv',
  },
  bazonline: {
    id: 'bazonline',
    number: 5,
    locale: 'de',
    url: 'bazonline.ch',
    subdomain: 'interaktiv',
    category: 'Interaktiv',
  },
  '24heures': {
    id: '24heures',
    number: 15,
    locale: 'fr',
    url: '24heures.ch',
    subdomain: 'interactif',
    category: 'Interactif',
  },
  derbund: {
    id: 'derbund',
    number: 1,
    locale: 'de',
    url: 'derbund.ch',
    subdomain: 'interaktiv',
    category: 'Interaktiv',
  },
  tagesanzeiger: {
    id: 'tagesanzeiger',
    number: 2,
    locale: 'de',
    url: 'tagesanzeiger.ch',
    subdomain: 'interaktiv',
    category: 'Interaktiv',
  },
}

const TENANT_COLORS: { [key in Tenant]: string } = {
  bernerzeitung: '#800000',
  berneroberlaender: '#800000',
  langenthalertagblatt: '#800000',
  thunertagblatt: '#800000',
  zsz: '#2C3890',
  tdg: '#2C3890',
  zuonline: '#2C3890',
  landbote: '#2C3890',
  bazonline: '#D9010E',
  '24heures': '#D9010E',
  derbund: '#0085AB',
  tagesanzeiger: '#0078BD',
}

const TENANT_COLORS_DARK: { [key in Tenant]: string } = {
  bernerzeitung: '#9C3838',
  berneroberlaender: '#9C3838',
  langenthalertagblatt: '#9C3838',
  thunertagblatt: '#9C3838',
  zsz: '#2C3890',
  tdg: '#5A64A8',
  zuonline: '#5A64A8',
  landbote: '#2C3890',
  bazonline: '#D9010E',
  '24heures': '#D9010E',
  derbund: '#0085AB',
  tagesanzeiger: '#0078BD',
}

export const COLORS = {
  brandblue: {
    main: '#202346',
    bright_1: '#474A66',
    bright_2: '#6F7187',
    bright_3: '#9698A8',
    bright_4: '#C8C8D1',
    bright_5: '#F0F0F2',
  },
  yellow: { main: '#FFE462' },
  blue: {
    dark_2: '#1B475E',
    dark_1: '#296A8D',
    main: '#378EBD',
    bright_1: '#69AACD',
    bright_2: '#9BC6DE',
    bright_3: '#CDE2EE',
  },
  petrol: {
    dark_2: '#16514F',
    dark_1: '#217977',
    main: '#2CA29F',
    bright_1: '#60B9B7',
    bright_2: '#95D0CF',
    bright_3: '#CAE7E7',
  },
  green: {
    dark_2: '#234930',
    dark_1: '#356D48',
    main: '#479260',
    bright_1: '#75AD87',
    bright_2: '#A3C8AF',
    bright_3: '#D1E3D7',
  },
  purple: {
    dark_2: '#512A4F',
    dark_1: '#7A3F77',
    main: '#A757A3',
    bright_1: '#BA7FB7',
    bright_2: '#D1AACF',
    bright_3: '#E8D4E7',
  },
  orange: {
    dark_2: '#703600',
    dark_1: '#964800',
    main: '#E16D00',
    bright_1: '#E78D38',
    bright_2: '#F1BE8D',
    bright_3: '#F8DEC6',
  },
  red: {
    dark_2: '#691A1F',
    dark_1: '#9E272F',
    main: '#D3343F',
    bright_1: '#DE666F',
    bright_2: '#E9999F',
    bright_3: '#F4CCCF',
  },
  beige: {
    dark_2: '#575247',
    dark_1: '#7B7768',
    main: '#A09C8A',
    bright_1: '#DCD8C9',
    bright_2: '#EFECE0',
    bright_3: '#F8F7F4',
  },
  gray: {
    gray_1: '#121212',
    gray_2: '#555555',
    gray_3: '#7D7D7D',
    gray_4: '#D4D4D4',
    gray_5: '#E9E9E9',
    gray_6: '#F4F4F4',
  },
  tenants: TENANT_COLORS,
  tenants_dark: TENANT_COLORS_DARK,
}

export const FONTS = {
  plex: 'IBM Plex Sans, Helvetica, Arial, Verdana, sans-serif',
  noto: 'Noto Serif, serif',
  source: 'Source Serif, serif',
}

export const DEFAULT_THEME = {
  isDarkModeEnabled: false,
  tenant: COLORS.gray.gray_2,
  foreground: COLORS.brandblue.main,
  background: '#ffffff',
}

export const DUMMY_TEXT = `
  Als Gregor Samsa eines Morgens aus unruhigen Träumen erwachte, fand er sich in
  seinem Bett zu einem ungeheueren Ungeziefer verwandelt. Er lag auf seinem
  panzerartig harten Rücken und sah, wenn er den Kopf ein wenig hob, seinen
  gewölbten, braunen, von bogenförmigen Versteifungen geteilten Bauch, auf dessen
  Höhe sich die Bettdecke, zum gänzlichen Niedergleiten bereit, kaum noch
  erhalten konnte. Seine vielen, im Vergleich zu seinem sonstigen Umfang kläglich
  dünnen Beine flimmerten ihm hilflos vor den Augen.
  `
